import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PipesModule } from '@freelancer/pipes';
import { UiModule } from '@freelancer/ui';
import { InvitationActionLoadingComponent } from './invitation-action-loading/invitation-action-loading.component';
import { InvitationActionLoginSignupComponent } from './invitation-action-login-signup/invitation-action-login-signup.component';
import { InvitationActionComponent } from './invitation-action.component';

@NgModule({
  imports: [CommonModule, PipesModule, UiModule],
  exports: [InvitationActionComponent],
  declarations: [
    InvitationActionComponent,
    InvitationActionLoginSignupComponent,
    InvitationActionLoadingComponent,
  ],
})
export class InvitationActionModule {}
